import { Phone } from "lucide-react";

export default function CrisisBanner() {
  return (
    <div className="bg-navy text-white text-xs sm:text-sm" data-testid="crisis-banner">
      <div className="max-w-7xl mx-auto px-5 py-2.5 flex items-center justify-center gap-3 text-center flex-wrap">
        <span className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-teal pulse-dot" aria-hidden="true" />
          <span className="tracking-wide font-semibold">It's OK not to be OK.</span>
        </span>
        <span className="opacity-80 hidden sm:inline">In crisis — call or text</span>
        <a
          href="tel:988"
          className="inline-flex items-center gap-1.5 underline underline-offset-4 decoration-teal hover:text-teal transition-colors font-semibold"
          data-testid="crisis-banner-988-link"
        >
          <Phone className="w-3.5 h-3.5" />
          988
        </a>
        <span className="opacity-80 hidden sm:inline">— 24/7, free &amp; confidential.</span>
      </div>
    </div>
  );
}
